import { RequestParams, ResponseCatalog } from 'Models'
import { urls } from 'Src/constants/Urls'
import { GosbCreateRequestModel, GosbModel } from 'Pages/referenceBooks'
import { axiosDS } from '@pp/axios'

export const gosbApi = {
	getAll: async (params?: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<GosbModel>>(urls.referenceBook.gosb, { params })
		return res.data
	},

	createOne: async (data: GosbCreateRequestModel) => {
		const res = await axiosDS().post<GosbModel>(urls.referenceBook.gosb, { data })
		return res.data
	},

	getOne: async (id: number) => {
		const res = await axiosDS().get<GosbModel>(`${urls.referenceBook.gosb}/${id}`)
		return res.data
	},

	updateOne: async (data: GosbModel) => {
		const res = await axiosDS().patch<GosbModel>(`${urls.referenceBook.gosb}/${data.id}`, { data })
		return res.data
	},
}
